export default __webpack_public_path__ + "media/zurb/img/playground/landing-page-6477fb77b2e99ae9220ee549a88ff86a.png";